export default (video) => {
  const id = video.photo_id || video.live_id || video.object_id
  const stub = video.tree_id || 'thumbnail'
  return `/${stub}/${id}/${video.token}/400x300cr/thumbnail.jpeg`
}

export const getImageThumbnail = (id, size) => {
  return `/thumbnail-cookie/${id}/${size}/thumbnail.jpg`
}
